import React, { memo, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styles from "./BillsLayout.module.scss";
import BillsHeader from "./components/BillsHeader";
import { useSelector } from "react-redux";
import { RootState } from "../../stores/store";
import ButtomNav from "./components/ButtomNav";
import BillsSideMenu from "./components/BillsSidemenu";
import CountrySelector from "./country-selector/CountrySelector";
import { ApplicationRoutes } from "../../routes";
import { SubMenuData, SubMenuInteraction } from "../menu.types";
import BillSubMenu from "./components/BillSubMenu";
import { MENU_STRUCTURE } from "./BillMenu.constant";
import { useConfigLayout } from "../../hooks/useConfigLayout";

type Props = {};

const BillsLayout: React.FC<Props> = memo((props: Props) => {
	const [isColapsed, setIsColapsed] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	const [currentSubMenu, setCurrentSubMenu] = useState<SubMenuInteraction | null>(null);

	useConfigLayout({
		showCountrySelector: true,
		utility: null,
		showExportButton: false,
		showBreadCrumb: true,
		exportHandler: () => {},
	});

	const location = useLocation();
	const firstLogin = useSelector((state: RootState) => state.firstLogin.firstLogin);

	const getActiveSubMenuFromUrl = (currentPath: string) => {
		let menuItems;

		switch (true) {
			case currentPath.includes(ApplicationRoutes.ADMIN_BILLS):
				menuItems = MENU_STRUCTURE.bills;
				break;
			case currentPath.includes(ApplicationRoutes.SOLAR_MARKET):
				menuItems = MENU_STRUCTURE.marketplace;
				break;
			default:
				return null; 
		}

		// Find the active submenu item
		for (const menuItem of menuItems) {
			// Check if any submenu item matches the current path
			if (menuItem.subMenuItems && menuItem.subMenuItems.length > 0) {
				const activeSubMenuItem = menuItem.subMenuItems.find(subItem => currentPath === subItem.route);

				if (activeSubMenuItem) {
					return {
						mainMenuName: menuItem.text,
						subMenuItems: menuItem.subMenuItems,
						isOpen: true,
						activeSubMenuItem: activeSubMenuItem.text,
					};
				}
			}
		}

		return null;
	};

	function toggleColapsed() {
		setIsColapsed(!isColapsed);
	}

	function toggleMobileMenu() {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	}

	const handleSubMenuInteraction = (mainMenuName: string, subMenuItems: SubMenuData[], isOpen: boolean, activeSubMenuItem?: string) => {
		const subMenuData: SubMenuInteraction = {
			mainMenuName,
			subMenuItems,
			isOpen,
			activeSubMenuItem,
		};

		setCurrentSubMenu(subMenuData);
	};

	useEffect(() => {
		const activeSubMenu = getActiveSubMenuFromUrl(location.pathname);
		if (activeSubMenu) {
			setCurrentSubMenu(activeSubMenu);
		} else {
			// If no submenu should be active, close all submenus
			setCurrentSubMenu(null);
		}
	}, [location.pathname]);

	useEffect(() => {
		if (currentSubMenu) {
			// Do something when submenu state changes
			console.log("Current submenu changed:", currentSubMenu);
		}
	}, [currentSubMenu]);

	useEffect(() => {
		setIsDisabled(firstLogin);
	}, [firstLogin]);

	return (
		<div className={styles.container}>
			<BillsSideMenu
				onSubMenuInteraction={handleSubMenuInteraction}
				mobileMenuOpen={isMobileMenuOpen}
				onMobileMenuClick={toggleMobileMenu}
				isColapsed={false}
				isDisabled={false}
			/>
			<CountrySelector />
			{currentSubMenu && <BillSubMenu menu={currentSubMenu} />}
			<div className={styles.contentContainer}>
				<BillsHeader onMobileMenuClick={toggleMobileMenu} />
				<div className={`${styles.content} ${isColapsed ? styles.contentWidthCollapsedSideMenu : styles.contentWidthExpandedSideMenu}`}>
					<Outlet />
				</div>
				<ButtomNav />
			</div>
		</div>
	);
});

export default BillsLayout;
